<template>
  <div class="shipment-status">
    <div class="f-c shipment-status">
      <div class="info-board">
        <div class="stats-info-card blue-business-bg">
          <div class="info-card-left">
            <span class="title">
              {{ outboundPalletCount }} / {{ palletCount }} Pallets
            </span>
            <span class="sub-title">Prepared</span>
          </div>
        </div>
        <div class="stats-info-card blue-business-bg">
          <div class="info-card-left">
            <span class="title">
              {{ outboundPalletCount }} / {{ palletCount }} Pallets
            </span>
            <span class="sub-title">Loaded</span>
          </div>
        </div>
        <div class="stats-info-card blue-business-bg">
          <div class="info-card-left">
            <span class="title">{{ stageNo || 'Not Set' }}</span>
            <span class="sub-title">Stage</span>
          </div>
        </div>
        <div class="stats-info-card blue-business-bg">
          <div class="info-card-left">
            <span class="title">{{ dockNo || 'Not Set' }}</span>
            <span class="sub-title">Dock</span>
          </div>
        </div>
        <div class="stats-info-card warn-bg" v-if="isShipmentReady">
          <div class="info-card-left">
            <span class="title">Ready for</span>
            <span class="sub-title">Shipping</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// components

// modesl
import {
  ShipmentWorking,
  ShipmentShipping,
  ShipmentDelivered
} from '@/core/models/shipment'
import { PalletOnStage } from '@/core/models/pallet'
export default {
  name: 'ShipmentStatus',
  components: {},
  props: {
    shipment: {
      type: Object
    },
    pallets: {
      type: Array
    }
  },
  computed: {
    status() {
      return this.shipment?.status ?? ''
    },
    stageNo() {
      return this.shipment?.stageNo ?? ''
    },
    dockNo() {
      return this.shipment?.dockNo ?? ''
    },
    palletCount() {
      return this.shipment?.palletIds?.length ?? 0
    },
    outboundPalletCount() {
      return this.pallets.filter(p => p.status === PalletOnStage).length
    },
    loadedPalletCount() {
      return this.shipment?.loadedPalletIds.length
    },
    isShipmentReady() {
      const flag1 = this.shipment?.palletIds.length ?? 0
      if (!flag1) return false
      const flag2 = this.shipment?.loadedPalletIds?.length ?? 0
      return flag1 === flag2
    }
  },
  data() {
    return {
      ShipmentWorking,
      ShipmentShipping,
      ShipmentDelivered
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 20px;
  flex-wrap: wrap;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .f-r-vc;
}
</style>
